export enum MarketplaceMode {
  Edit = 'edit',
  Preview = 'preview',
}
